import { render, staticRenderFns } from "./BrandDetectionReport.vue?vue&type=template&id=f731b19a&scoped=true&"
import script from "./BrandDetectionReport.vue?vue&type=script&lang=js&"
export * from "./BrandDetectionReport.vue?vue&type=script&lang=js&"
import style0 from "./BrandDetectionReport.vue?vue&type=style&index=0&id=f731b19a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f731b19a",
  null
  
)

export default component.exports